import React, { useContext, useEffect, useRef, useState } from "react";
import SetupTimeline from "./SetupTimeline/SetupTimeline";
import LayoutAttach from "./LayoutAttach/LayoutAttach";
import SetupFooter from "./SetupFooter/SetupFooter";
import ProjectDetails from "./SetupDetails/ProjectDetails/ProjectDetails";
import BuildingDetails from "./SetupDetails/BuildingDetails/BuildingDetails";
import LevelDetails from "./SetupDetails/LevelDetails/LevelDetails";
import SpacesDetails from "./SetupDetails/SpacesDetails/SpacesDetails";
import * as Yup from "yup";
import { useFormik } from "formik";
import trans from "../../../../utils";
import { toast } from "react-toastify";
import {
	useAddPOIMutation,
	useEditPOIMutation,
	useGetSpecificPOIQuery,
} from "../../../../Redux/service/POIS/POIs";
import Loader from "../../../Helpers/Loader/Loader";
import { popupcontext } from "../../../../context/Popupscontext";
import SetupHeader from "./SetupHeader/SetupHeader";

export default function SetupSteps({
	page,
	setPage,
	setImageUrl,
	setSubmitAttempt,
	uniqueId,
	setUniqueId,
	imageUrl,
	submitAttempt,
	selected,
	setSelect,
	select,
	typeId,
	setSelected,
	setTypeId,
	setFetching,
	clear,
	setClear,
	setMode,
	back,
	setBack,
}) {
	const queryId = uniqueId ?? typeId;
	const [AddPOI, { isLoading: addLoading }] = useAddPOIMutation();
	const [EditPOI, { isLoading: editLoading }] = useEditPOIMutation();
	const {
		data: poi,
		refetch,
		isFetching,
		isSuccess,
		isLoading,
	} = useGetSpecificPOIQuery(queryId, {
		skip: !queryId,
	});
	const [type, setType] = useState("Project");
	const [projectId, setProjectId] = useState(null);
	const [buildingId, setBuildingId] = useState(null);
	const [levelId, setLevelId] = useState(null);
	const [poiAttachments, setPoiAttachments] = useState();
	const pageChangedRef = useRef(false);

	const [disableNext, setDisableNext] = useState(false);
	let {
		setKonvamode,
		konvaCoord,
		reloadData,
		setReloadData,
		setIsEditing,
		isEditing,
		attachmentsId,
		setAttachmentsId,
		continueSetup,
		setcurrentPOIId,
	} = useContext(popupcontext);
	const [checked, setChecked] = useState({
		0: false,
		1: false,
		2: false,
		3: false,
	});
	let initialValues = {
		name: null,
		status: true,
		type: null, // project , building , level , space
		latitude: 0,
		longitude: 0,
		address: null,
		notes: null,
		country: ".",
		state: ".",
		city: ".",
		contactPerson: {
			name: null,
		},
		customAttributes: null,
		attachments: [],
		attachmentsToDelete: null,
		parentId: null,
		contractorLogo: null,
		contractorLabel: null,
		customer1Logo: null,
		customer1Label: null,
		customer2Logo: null,
		customer2Label: null,
		consultantLogo: null,
		consultantLabel: null,
		layout: [],
		code: null,
		order: null, // level
		projectType: null, // project
		projectStatus: null, // project
		startDate: null, // projcet
		endDate: null, // project
		coordinates: null, // building,level,space
		formId: null,
	};
	let validSchema = Yup.object({
		name: Yup.string()
			.required(trans("Name is required"))
			.min(3, trans("Name must be at least 3 characters"))
			.test(
				"not-empty-or-spaces",
				trans("Name cannot be just whitespace"),
				(value) => !!value && value.trim().length > 0,
			),
		type: Yup.string().required(trans("Type is required")),
		code: Yup.string()
			.matches(
				/^[a-zA-Z0-9-]*$/,
				"Code cannot contain hyphens or special characters",
			)
			.required(trans("Code is required")),
		notes: Yup.string()
			.optional()
			.nullable()
			.test(
				"not-whitespace-only",
				trans("Notes cannot be just whitespace"),
				(value) => {
					if (value === null || value === undefined || value === "")
						return true; // allow empty
					return value.trim().length > 0; // disallow only whitespace
				},
			),
		formCategory:
			page === 1 && Yup.string().required(trans("Form category is required")),
		forms: page === 1 && Yup.string().required(trans("Form is required")),
		contactPerson: Yup.object()
			.shape({
				name: Yup.string()
					.nullable()
					.min(3, trans("Name must be at least 3 characters"))
					.test("not-empty", trans("Name cannot be just whitespace"), (val) => {
						if (!val) return true;
						return val.trim().length > 0;
					}),
			})
			.test(
				"all-or-none",
				trans("If any contact person field is filled, all must be provided"),
				function (value) {
					if (!value) return true;
					const { name } = value;
					const anyFilled = name;
					const allFilled = !!name?.toString().trim();
					// If one is filled but not all → error
					if (anyFilled && !allFilled) {
						return this.createError({
							message: trans(
								"All contact person fields are required if one is filled",
							),
						});
					}
					return true;
				},
			)
			.nullable(),
	});
	useEffect(() => {
		if (reloadData && queryId) {
			refetch();
		}
	}, [reloadData, queryId]);
	console.log("Selected Item", selected);
	console.log("Select", select);
	console.log("TYPEID", typeId, "UNIQUEID", uniqueId, "QueryId", queryId);
	useEffect(() => {
		if (attachmentsId?.length && isEditing) {
			addPOI.setFieldValue("attachmentsToDelete", attachmentsId);
		}
	}, [attachmentsId, isEditing]);

	useEffect(() => {
		if (page !== 1 && konvaCoord) {
			addPOI.setFieldValue(
				"coordinates",
				Array.isArray(konvaCoord?.drawingCoordinates)
					? konvaCoord?.drawingCoordinates
					: [konvaCoord?.drawingCoordinates],
			);
		}
	}, [page, konvaCoord, submitAttempt]);
	useEffect(() => {
		// ❌ Do nothing during submit / after resetForm
		if (submitAttempt) return;

		// ✅ EDIT MODE
		if (page !== 1 && select && selected?.polyid != null && poi?.data) {
			setKonvamode(false);
			setIsEditing(true);

			const poiData = poi.data;
			const formValues = addPOI.values;

			// ✅ Only set if different (prevents overwriting user edits)
			if (formValues.name !== poiData.name) {
				addPOI.setFieldValue("name", poiData.name ?? "");
			}

			if (formValues.code !== poiData.code) {
				addPOI.setFieldValue("code", poiData.code ?? "");
			}

			if (formValues.notes !== poiData.notes) {
				addPOI.setFieldValue("notes", poiData.notes ?? "");
			}

			if (
				JSON.stringify(formValues.attachments) !==
				JSON.stringify(poiData.attachments)
			) {
				addPOI.setFieldValue("attachments", poiData.attachments ?? []);
			}

			return;
		}

		// ✅ ADD MODE (no selection)
		if (page !== 1 && uniqueId === null) {
			setIsEditing(false);

			addPOI.setFieldValue("name", null);
			addPOI.setFieldValue("code", null);
			addPOI.setFieldValue("notes", null);
			addPOI.setFieldValue("attachments", []);
		}
	}, [
		page,
		select,
		selected?.polyid,
		poi?.data, // 🔥 THIS WAS MISSING
		submitAttempt,
	]);

	useEffect(() => {
		if (uniqueId === null || clear === true) {
			addPOI.setFieldValue("name", null);
			addPOI.setFieldTouched("name", false);
			addPOI.setFieldValue("code", null);
			addPOI.setFieldTouched("code", false);
			addPOI.setFieldValue("notes", null);
			addPOI.setFieldValue("attachments", []);
			setClear(false);
		}
	}, [uniqueId, clear]);
	useEffect(() => {
		pageChangedRef.current = true;

		addPOI.setFieldValue("attachments", []);
		addPOI.setFieldValue("attachmentsToDelete", []);
		setPoiAttachments([]);
	}, [page]);

	useEffect(() => {
		if (page !== 1 && queryId) {
			refetch();
			addPOI.setFieldValue("attachments", []);
			addPOI.setFieldValue("attachmentsToDelete", []);
		}
	}, [page, queryId, back]);
	let addPOI = useFormik({
		initialValues,
		context: { uniqueId }, // 👈 IMPORTANT
		validationSchema: validSchema,
		onSubmit: async (val, helpers) => {
			try {
				if (!select && (!val.layout || val.layout.length === 0) && page !== 4) {
					helpers.setFieldError("layout", trans("Layout is required"));
					return; // stop submission
				}
				const { attachmentsToDelete, ...rest } = val;
				let postValues = {
					...rest,
					code: rest.code?.toUpperCase(),
				};
				if (select) {
					postValues.attachmentsToDelete = attachmentsToDelete ?? [];

					delete postValues.code;
					delete postValues.layout;
					delete postValues.coordinates;
				}
				if (!select) {
					delete postValues.attachmentsToDelete;
				}
				setFetching(true);
				const response =
					select && selected?.polyid !== null && selected?.polyid !== undefined
						? await EditPOI({
								id: uniqueId,
								val: postValues,
							}).unwrap()
						: await AddPOI(postValues).unwrap();
				toast.success(
					trans(
						`${type} Is ${
							select &&
							selected?.polyid !== null &&
							selected?.polyid !== undefined
								? "Edited"
								: "Added"
						} Successfully`,
					),
					{
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					},
				);
				if (page === 1) {
					setChecked((prev) => ({ ...prev, 0: true }));
					setProjectId(response?.data?.id);
				} else if (page === 2) {
					setChecked((prev) => ({ ...prev, 1: true }));
					setBuildingId(response?.data?.id);
				} else if (page === 3) {
					setChecked((prev) => ({ ...prev, 2: true }));
					setLevelId(response?.data?.id);
				} else if (page === 4) {
					setChecked((prev) => ({ ...prev, 3: true }));
				}

				if (page === 1) {
					setPage(page + 1);
					// await setImageUrl(response?.data?.floorPlanImageUrl);
				}
				setIsEditing(false);
				if (
					select &&
					selected?.polyid !== null &&
					selected?.polyid !== undefined
				) {
					setKonvamode(false);
					// setPoiAttachments([]);
					setAttachmentsId([]);
				} else {
					setKonvamode(true);
					addPOI.resetForm();
				}
				setReloadData(true);
				setUniqueId(response?.data?.id);
				if (select === false && page === 1) setTypeId(response?.data?.id);
				setSubmitAttempt(false);
				setFetching(false);
				setAttachmentsId([]);
				await addPOI.setFieldValue("attachmentsToDelete", []);
				await addPOI.setFieldValue("attachments", []);
			} catch (error) {
				console.log(error);
				setMode("none");
				toast.error(`${error?.data?.message}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});

	// const initializedAttachments = useRef(false);

	// useEffect(() => {
	// 	if (!select || !isSuccess || isFetching) return;

	// 	const apiAttachments = poi?.data?.attachments ?? [];

	// 	// 🔥 API is the single source of truth
	// 	setPoiAttachments(apiAttachments);
	// 	addPOI.setFieldValue("attachments", apiAttachments);
	// }, [select, isSuccess, isFetching, poi?.data?.attachments]);
	const ranOnce = useRef(false);
	console.log("AddPoi", addPOI);

	useEffect(() => {
		if (!select) return;

		if (!isSuccess || isFetching) return;
		// if (pageChangedRef.current) {
		// 	console.log("PAGE CHANGED - SKIPPING SETTING POI");
		// 	pageChangedRef.current = false; // reset flag
		// 	return;
		// }
		// console.log("ENTERED SETTING POI");
		// Only set poiAttachments when API data changes
		const apiAttachments = poi?.data?.attachments ?? [];
		console.log("API ATTACHMENTS", apiAttachments);
		setPoiAttachments(apiAttachments);

		// Optionally update the form value to match API
		addPOI.setFieldValue("attachments", apiAttachments);
	}, [select, poi?.data?.attachments, isSuccess, isFetching]);

	console.log("Val", addPOI);
	useEffect(() => {
		if (!select) {
			addPOI.setFieldValue("attachments", []);
			addPOI.setFieldValue("attachmentsToDelete", []);
			setPoiAttachments([]);
		}
	}, [select]);

	useEffect(() => {
		if (page === 1) {
			setType("Project");
			addPOI.setFieldValue("type", "project");
		} else if (page === 2) {
			setType("Building");
			addPOI.setFieldValue("parentId", projectId);
			addPOI.setFieldValue("type", "zone");
		} else if (page === 3) {
			setType("Level");
			if (buildingId) addPOI.setFieldValue("parentId", buildingId);
			addPOI.setFieldValue("type", "level");
		} else if (page === 4) {
			if (levelId) addPOI.setFieldValue("parentId", levelId);
			setType("Space");
			addPOI.setFieldValue("type", "room");
		}
	}, [page, submitAttempt, back]);
	useEffect(() => {
		if (continueSetup) {
			if (page === 2) {
				setProjectId(typeId);
				addPOI.setFieldValue("parentId", projectId);
			} else if (page === 3) {
				setBuildingId(typeId);
				addPOI.setFieldValue("parentId", buildingId);
			} else if (page === 4) {
				setLevelId(typeId);
				addPOI.setFieldValue("parentId", levelId);
			}
		}
	}, [continueSetup, page, back]);
	const handleSubmit = (e) => {
		e.preventDefault();
		setSubmitAttempt(true);
		addPOI.handleSubmit(e);
	};
	const finalPoiAttachments = Array.isArray(addPOI.values.attachments)
		? addPOI.values.attachments
		: [];

	const details = () => {
		if (page === 1) {
			return <ProjectDetails addPOI={addPOI} />;
		} else if (page === 2) {
			return (
				<BuildingDetails
					addPOI={addPOI}
					uniqueId={uniqueId}
					selected={selected}
					select={select}
					poiAttachments={poiAttachments}
					Loading={isLoading}
					clear={clear}
				/>
			);
		} else if (page === 3) {
			return (
				<LevelDetails
					addPOI={addPOI}
					uniqueId={uniqueId}
					selected={selected}
					select={select}
					poiAttachments={poiAttachments}
					Loading={isLoading}
					clear={clear}
				/>
			);
		} else if (page === 4) {
			return (
				<SpacesDetails
					addPOI={addPOI}
					uniqueId={uniqueId}
					selected={selected}
					select={select}
					poiAttachments={poiAttachments}
					Loading={isLoading}
					clear={clear}
				/>
			);
		} else {
			return <ProjectDetails addPOI={addPOI} />;
		}
	};
	useEffect(() => {
		return () => setcurrentPOIId(null);
	}, [setcurrentPOIId]);

	return (
		<form
			onSubmit={handleSubmit}
			style={{
				width: "100%",
				backgroundColor: "white",
				height: "calc(100vh - 64px)",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					flex: 1,
					overflowY: "auto",
					// paddingBlock: "16px",
				}}
			>
				<SetupHeader
					type={type}
					page={page}
					setPage={setPage}
					setTypeId={setTypeId}
					buildingId={buildingId}
					projectId={projectId}
					setUniqueId={setUniqueId}
					typeId={typeId}
					setSelect={setSelect}
					setSelected={setSelected}
					back={back}
					setBack={setBack}
					addPOI={addPOI}
					setPoiAttachments={setPoiAttachments}
				/>
				{continueSetup === false && (
					<SetupTimeline page={page} checked={checked} />
				)}{" "}
				{addLoading || editLoading ? (
					<div className="loader-container">
						<Loader />
					</div>
				) : (
					<>
						{(selected?.polyid === null || selected?.polyid === undefined) &&
							page !== 4 && <LayoutAttach page={page} addPOI={addPOI} />}
						{details()}
					</>
				)}
			</div>

			<SetupFooter
				setPage={setPage}
				page={page}
				loading={addLoading}
				handleSubmit={handleSubmit}
				setDisableNext={setDisableNext}
				setUniqueId={setUniqueId}
				uniqueId={uniqueId}
				selectedId={selected?.polyid}
				select={select}
				setTypeId={setTypeId}
				setSelect={setSelect}
				setSelected={setSelected}
				pushImage={() => setImageUrl(poi?.data?.floorPlan?.ImageUrl)}
			/>
		</form>
	);
}
